    import React from 'react';
    import { motion } from 'framer-motion';
    import { useInView } from 'react-intersection-observer';
    import { FaLinkedin } from "react-icons/fa";
    import { Link } from 'react-router-dom';
    import logo from '../assets/efa_logo.png';

    import {
      HiMail,
      HiPhone,
      HiLocationMarker,
      HiArrowUp
    } from 'react-icons/hi';
    // Removed unused Fa icons imports

    const Footer = () => {
      const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.1
      });

      const scrollToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      };

      const scrollToSection = (id) => {
  const section = document.getElementById(id);
  if (section) {
    section.scrollIntoView({ behavior: "smooth" });
  }
};


      const footerLinks = {
  services: [
    { name: "Web Development", action: () => scrollToSection("services") },
    { name: "Mobile Apps", action: () => scrollToSection("services") },
    { name: "Cloud Solutions", action: () => scrollToSection("services") },
    { name: "AI Solutions", action: () => scrollToSection("services") }
  ],
  company: [
    { name: "Home", action: scrollToTop },
    { name: "About Us", action: () => scrollToSection("about") },
    { name: "Our Team", action: () => scrollToSection("about") },
    { name: "Careers", action: () => scrollToSection("services") },
    { name: "Contact", action: () => scrollToSection("contact") }
  ]
};

      // Removed the entire socialLinks constant and its JSX block

      const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
          opacity: 1,
          transition: {
            staggerChildren: 0.2,
            delayChildren: 0.1
          }
        }
      };

      const itemVariants = {
        hidden: { y: 30, opacity: 0 },
        visible: {
          y: 0,
          opacity: 1,
          transition: { duration: 0.6, ease: "easeOut" }
        }
      };

      return (
        <footer className="bg-neutral-900 text-white relative overflow-hidden"> {/* Changed bg-gray-900 to bg-neutral-900 */}
          {/* Minimal Animated Background */}
          <div className="absolute inset-0 overflow-hidden">
            {/* Subtle single gradient blob */}
            <motion.div
              className="absolute -bottom-32 -right-32 w-64 h-64 bg-primary-600 rounded-full opacity-10"
              animate={{
                scale: [1, 1.1, 1],
              }}
              transition={{
                duration: 12,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            />
          </div>

          <div className="container-custom px-6 sm:px-8 lg:px-12 relative z-10">
            <motion.div
              ref={ref}
              variants={containerVariants}
              initial="hidden"
              animate={inView ? "visible" : "hidden"}
              className="py-10"
            >
              {/* Compact Grid Layout */}
              <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6 text-center md:text-left">
                {/* Company Info */}
                <motion.div variants={itemVariants} className="lg:col-span-2">
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    className="flex items-center justify-center md:justify-start space-x-2 mb-4"
                  >
                    <Link to="/" className="flex items-center space-x-3">
                      <div className="bg-white rounded-lg p-1.5">
                        <img src={logo} alt="EFA Tech Solutions Logo" className="w-10 h-10" />
                      </div>
                      <span className="text-lg font-bold text-neutral-100">EFA Tech Solutions</span>
                    </Link>
                  </motion.div>

                  <p className="text-neutral-400 mb-4 text-sm max-w-sm mx-auto md:mx-0">
                    Empowering businesses with cutting-edge technology solutions that drive innovation, efficiency, and growth in the digital age.
                  </p>

                  {/* Contact Info - Compact */}
                  <div className="space-y-2 text-sm">
                    <div className="flex items-center justify-center md:justify-start space-x-2">
                      <HiMail className="w-4 h-4 text-primary-400 flex-shrink-0" />
                      <span className="text-neutral-400">hr@efatechsolutions.com</span>
                    </div>
                    <div className="flex items-center justify-center md:justify-start space-x-2">
                      <HiPhone className="w-4 h-4 text-primary-400 flex-shrink-0" />
                      <span className="text-neutral-400">+91 9515212971</span>
                    </div>
                    <div className="flex items-start justify-center md:justify-start space-x-2">
                      <HiLocationMarker className="w-4 h-4 text-primary-400 flex-shrink-0 mt-0.5" />
                      <span className="text-neutral-400 text-xs">Karimnagar IT Towers - opposite Ujwala Park, Rampur, Karimnagar, Telangana 505001</span>
                    </div>

                    <div className="flex items-center justify-center md:justify-start space-x-2 mt-3">
    <FaLinkedin className="w-4 h-4 text-primary-400 flex-shrink-0" />
    <a
      href=" https://www.linkedin.com/company/efa-tech-solutions/"
      target="_blank"
      rel="noopener noreferrer"
      className="text-neutral-400 hover:text-primary-400 transition-colors"
    >
      LinkedIn
    </a>
  </div>
                  </div>
                </motion.div>

                {/* Services */}
                <motion.div variants={itemVariants} className="text-center md:text-left">
                  <h3 className="text-sm font-bold mb-4 text-neutral-100 uppercase tracking-wide">Services</h3>
                  <ul className="space-y-2 text-sm">
                    {footerLinks.services.map((link, index) => (
                      <li key={index}>
                        <button
  type="button"
  onClick={link.action}
  className="text-neutral-400 hover:text-primary-400 transition-colors duration-300"
>
  {link.name}
</button>

                      </li>
                    ))}
                  </ul>
                </motion.div>

                {/* Company */}
                <motion.div variants={itemVariants} className="text-center md:text-left">
                  <h3 className="text-sm font-bold mb-4 text-neutral-100 uppercase tracking-wide">Company</h3>
                  <ul className="space-y-2 text-sm">
                    {footerLinks.company.map((link, index) => (
                      <li key={index}>
                        <button
  type="button"
  onClick={link.action}
  className="text-neutral-400 hover:text-primary-400 transition-colors duration-300"
>
  {link.name}
</button>

                      </li>
                    ))}
                  </ul>
                </motion.div>
              </div>
            </motion.div>

            

            {/* Bottom Bar */}
            <motion.div
              variants={itemVariants}
              className="py-4 border-t border-neutral-800 flex flex-col md:flex-row justify-between items-center text-center text-xs md:text-sm gap-4"
            >
              <p className="text-neutral-500">
                © {new Date().getFullYear()} EFA Tech Solutions. All rights reserved.
              </p>

              <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
  <button type="button" className="text-neutral-500 hover:text-primary-400 transition-colors">
    Privacy Policy
  </button>
  <button type="button" className="text-neutral-500 hover:text-primary-400 transition-colors">
    Terms of Service
  </button>
  <button type="button" className="text-neutral-500 hover:text-primary-400 transition-colors">
    Cookie Policy
  </button>
</div>

            </motion.div>
          </div>

          {/* Simple Scroll to Top Button */}
          <motion.button
            onClick={scrollToTop}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            className="fixed bottom-8 right-8 w-12 h-12 bg-primary-600 rounded-full flex items-center justify-center text-white shadow-lg hover:bg-primary-700 transition-all duration-300 z-50" // Changed bg-blue-600 to bg-primary-600, hover:bg-blue-700 to hover:bg-primary-700
          >
            <HiArrowUp className="w-6 h-6" />
          </motion.button>

          
        </footer>
      );
    };

    export default Footer;
